import { render, staticRenderFns } from "./NewFilePage.vue?vue&type=template&id=a97f1af8&"
import script from "./NewFilePage.vue?vue&type=script&lang=js&"
export * from "./NewFilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports